import React, { useState } from 'react';
import Button from './Button.jsx';
import CompanyInfoFields, { EMPTY_COMPANY_INFO_FORM, validateCompanyInfo } from './CompanyInfoFields.jsx';
import api from '../services/api';

const calculateEndDate = (startDate) => {
  const start = new Date(`${startDate}T00:00:00`);
  if (Number.isNaN(start.getTime())) return '';
  const end = new Date(start);
  end.setFullYear(end.getFullYear() + 1);
  end.setDate(end.getDate() - 1);
  return end.toISOString().slice(0, 10);
};

const CreateCompanyWizard = ({ onDone }) => {
  const [form, setForm] = useState(EMPTY_COMPANY_INFO_FORM);
  const [label, setLabel] = useState('');
  const [errors, setErrors] = useState({});
  const [banner, setBanner] = useState(null); // { type: 'error', text }
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm(prev => ({ ...prev, [name]: value }));
    setErrors(prev => ({ ...prev, [name]: undefined }));
    setBanner(null);
  };

  const handleLabelChange = (e) => {
    setLabel(e.target.value);
    setBanner(null);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const errs = validateCompanyInfo(form);
    if (!form.financial_year_start) errs.financial_year_start = 'Financial year start is required';
    setErrors(errs);
    if (Object.keys(errs).length > 0) return;

    setIsSubmitting(true);
    setBanner(null);
    try {
      const res = await api.post('/core/companies/create-full/', {
        ...form,
        end_date: calculateEndDate(form.financial_year_start),
        label,
      });
      localStorage.setItem('access_token', res.data.access);
      localStorage.setItem('refresh_token', res.data.refresh);
      localStorage.setItem('company_id', res.data.id);
      localStorage.setItem('financial_year_id', res.data.financial_year_id);
      onDone();
    } catch (err) {
      setBanner({ type: 'error', text: err.response?.data?.error || 'Failed to create company. Please try again.' });
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <form onSubmit={handleSubmit}>
      {banner && <div className="error-banner">{banner.text}</div>}

      <CompanyInfoFields
        form={form}
        errors={errors}
        onChange={handleChange}
        canEdit
        label={label}
        onLabelChange={handleLabelChange}
      />

      <Button type="submit" fullWidth disabled={isSubmitting}>
        {isSubmitting ? 'Creating...' : 'Create Company'}
      </Button>
    </form>
  );
};

export default CreateCompanyWizard;
